<template>
  <v-container fluid class="px-0 py-0">
    <p class="sys-info">我们会不断为道路运输企业提供更多常用、实用的安全生产管理工具。<br /> 敬请期待～ <br />需求反馈邮箱：<a
        href="mailto:ceo@anjia365.com">ceo@anjia365.com</a></p>
    <div class="modules un-sel-modules" v-if="unSels && unSels.length > 0">
      <h4>未开通应用</h4>
      <v-divider />
      <p class="desc">可以点击应用模块对应的<v-icon>add</v-icon>添加应用。</p>
      <v-card class="module" v-for="(m, i) in unSels" :key="m.id" :color="colors[i]">
        <img :src="m.icon" />
        <h5>
          {{ m.name
          }}<v-icon color="white" @click="addModule(m.id)">add</v-icon>
        </h5>
        <p>{{ m.desc }}</p>
      </v-card>
    </div>
    <div class="modules sel-modules" v-if="sels && sels.length > 0">
      <h4>已开通应用</h4>
      <v-divider />
      <v-card class="module" v-for="(m, i) in sels" :key="m.id" :color="colors[unSels.length + i]">
        <img :src="m.icon" />
        <h5>{{ m.name }}<v-icon color="white" @click="onRoleSettings(m.id)">settings</v-icon>
        </h5>
        <div>
          <i>状态：{{
      m.s.status === 0
        ? "停用"
        : m.s.status === 1
          ? "待开通"
          : m.s.status === 2
            ? m.s.expired
              ? "过期"
              : "开通"
            : "禁用"
    }}</i><br /><i>开通日期：{{ m.s.createTime | formatDate }}</i>
        </div>
        <v-divider color="white" />
        <p>{{ m.desc }}</p>
      </v-card>
    </div>
  </v-container>
</template>
<script>
const AdminModuleRoleSetting = () => import("../views/admin-module-role-setting.vue");
export default {
  name: "admin-module",
  data() {
    return {
      sels: [],
      unSels: [],
      colors: this.$colors,
    };
  },
  methods: {
    init() {
      let self = this;
      //加载模块信息
      self.$axios.get(`/home/admin/my/tenant/module/list`).then((r) => {
        let modules = r.data.message,
          selected = r.data.selected || [];
        //处理已开通模块，未开通模块，并且注入模块的icon路径
        let unSels = [],
          sels = [],
          hash = {};
        for (let s of selected) {
          hash[s.moduleId] = s;
        }
        for (let m of modules) {
          m.icon = `${self.$const.baseUrl}/home/admin/my/tenant/module/icon/${m.id}.png`;
          let s = hash[m.id];
          if (s) {
            m.s = s;
            sels.push(m);
          } else {
            unSels.push(m);
          }
        }
        self.sels = sels;
        self.unSels = unSels;
      });
    },
    addModule(id) {
      let self = this;

      self.$axios.get(`/home/admin/my/tenant/module/open/${id}`).then((r) => {
        if (r.data.status != "ok") {
          self.$status(r.data.message || "开通失败～", "error");
          return;
        }
        self.init();
        self.$axios.get(`/home/admin/my/tenant/module/role/cfg/${id}`).then(rr => {
          let roles = rr.data.message, accs = rr.data.accounts;
          if (roles.length > 0 && accs.length > 0) {
            self.$dialog.confirm('现在就为相关管理人员分配该应用的管理权限？', () => {
              setTimeout(() => {
                self.$dialog.component('应用权限分配', AdminModuleRoleSetting, { width: 800, mid: id, roles: roles, accs: accs }, [{
                  label: '确认保存', color: 'primary', func(c) {
                    self.saveRoles(id, c.cfg.accs);
                  }
                }]);
              }, 100);
            });
          }
        });

      });
    },
    onRoleSettings(mid) {
      let self = this;
      self.$axios.get(`/home/admin/my/tenant/module/role/cfg/${mid}`).then(rr => {
        let roles = rr.data.message, accs = rr.data.accounts;
        if (accs.length <= 0) {
          self.$status('没有可分配权限的账号，请先创建管理员账号～');
          return;
        }
        if (roles.length <= 0) {
          self.$status('该应用不需要权限分配～');
          return;
        }
        self.$dialog.component('应用权限分配', AdminModuleRoleSetting, { width: 800, mid: mid, roles: roles, accs: accs }, [{
          label: '确认保存', color: 'primary', func(c) {
            self.saveRoles(mid, c.cfg.accs);
          }
        }]);
      });
    },
    saveRoles(mid, accs) {
      let self = this, roles = [];
      for (let a of accs) {
        let tRoles = [];
        for (let r in a.roles) {
          if (a.roles[r]) {
            tRoles.push(r);
          }
        }
        if (tRoles.length > 0) {
          roles.push(`${a.id}:${tRoles.join(',')}`);
        }
      }

      if (roles.length > 0) {
        self.$axios.post(`/home/admin/my/tenant/module/role/cfg/${mid}/${roles.join('/')}`).then(r => {
          self.$dialog.close();
          if (r.data.status == 'ok') {
            self.$status('分配权限成功～', 'success');
          } else {
            self.$status(r.data.message || '分配权限失败～', 'error');
          }
        });
      }
    }
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
.v-divider {
  margin: 8px 0;
}

.modules {
  clear: both;
}

.modules .desc {
  font-size: 12px;
}

.module {
  width: 200px;
  float: left;
  color: white;
  margin-right: 16px;
  margin-bottom: 16px;
  padding: 8px;
  text-align: center;
}

.sel-modules .module {
  height: 240px;
}

.un-sel-modules .module {
  height: 240px;
}

.module img {
  width: 100px;
  display: block;
  margin: auto;
}

.module h5 {
  font-weight: bold;
  font-size: 14px;
}

.module p,
.module div {
  font-size: 10px;
}

.module .v-icon {
  cursor: pointer;
}
</style>
